// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-red-envelope{position:fixed;top:0;right:0;bottom:0;left:0;z-index:9999;background-color:rgba(0,0,0,.65);background-image:linear-gradient(180deg, rgba(255, 88, 74, 0.33) 0%, rgba(0, 0, 0, 0) 54%, rgba(160, 25, 20, 0.3) 100%)}.plv-iar-red-envelope__popup{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
